import { createSlice } from "@reduxjs/toolkit";
import { fetchArticleActionReport, fetchArticleActionReportTableColumnNames, 
  fetchArticleTableColumnNames, updateJsonField, updateJsonStatus, fetchLawDocuments
 } from "../thunks";



const initialState = {
  documents: [],
  tableColumnNames: [],
  articleColumnNames: [],
  lawDocuments: [],
  page: 1,
  perPage: 10,
  totalRecords: 0,
  loading: false,
  documentLoading: false,
  error: null
};

const ArticleActionReportSlice = createSlice({
  name: "ArticleActionReport",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
      state.page = 1; // ✅ Reset page on perPage change
    },
    updateArticleActionReport: (state, action) => {
      state.documents = state.documents.map((item) =>
        item.ID == action.payload.ID
          ? {
              ...item,
              Json: action.payload.Json,
              Articles: (item.Articles || []).map((article) =>
                article.article_number_numeric == action.payload.article_number_numeric
                ? {
                    ...article,
                    Json: action.payload.Json,
                    article_actions: action.payload.article_actions,
                  }
                : {
                  ...article,
                  Json: action.payload.Json
                }
              ),
            }
          : item
      );
    },
    clearArticleActionReport: (state) => {
      state.documents = []
    }
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchArticleActionReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchArticleActionReport.fulfilled, (state, action) => {
      state.loading = false;
      state.documents = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
      // const merged = [...state.documents, ...action.payload.data];
      // state.totalRecords = action.payload.totalRecords;
      // state.documents = Array.from(
      //   new Map(merged.map(item => [item.ID, item])).values()
      // ).sort((a, b) => b.ID - a.ID); 
    })
    .addCase(fetchArticleActionReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    .addCase(fetchArticleActionReportTableColumnNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchArticleActionReportTableColumnNames.fulfilled, (state, action) => {
      state.loading = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchArticleActionReportTableColumnNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
   
    .addCase(fetchArticleTableColumnNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchArticleTableColumnNames.fulfilled, (state, action) => {
      state.loading = false;
      state.articleColumnNames = action.payload;
    })
    .addCase(fetchArticleTableColumnNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(updateJsonField.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonField.fulfilled, (state, action) => {
      state.documents = state.documents.map((item) =>
        item.ID == action.payload.ID
          ? {
              ...item,
              JsonFieldUpdated: action.payload.JsonFieldUpdated,
              Articles: (item.Articles || []).map((article) => ({
                ...article,
                JsonFieldUpdated: action.payload.JsonFieldUpdated,
              })),
            }
          : item
      );
    })
    .addCase(updateJsonField.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(updateJsonStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonStatus.fulfilled, (state, action) => {
      state.documents = state.documents.map((item) =>
        item.ID === action.payload.ID
          ? { ...item, ArticleActionStatus: action.payload.ArticleActionStatus }
          : item
      );
    })
    .addCase(updateJsonStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(fetchLawDocuments.pending, (state) => {
      state.documentLoading = false
      state.error = null;
    })
    .addCase(fetchLawDocuments.fulfilled, (state, action) => {
      state.documentLoading = true
      state.lawDocuments = action.payload;
    })
    .addCase(fetchLawDocuments.rejected, (state, action) => {
      state.documentLoading = false
      state.error = action.payload;
    })
  },
});

export const { setPage, setPerPage, updateArticleActionReport, clearArticleActionReport } = ArticleActionReportSlice.actions;
export default ArticleActionReportSlice.reducer;